/**
 * Atividade de VÁRIOS projetos numa timeline só, pro painel "Atividade Recente" da lista de
 * projetos. Chama montarTimeline (já em produção, aba Atividade de cada projeto) uma vez por
 * projeto e junta o resultado — timeline.ts e seus testes ficam intocados.
 */
import { montarTimeline, type ItemAtividade } from './timeline.ts';

export interface ProjetoComEntradas {
  projetoId: number;
  projetoNome: string;
  /** Mesma forma que montarTimeline já aceita — não duplicamos o tipo aqui. */
  entradas: Parameters<typeof montarTimeline>[0];
}

export interface ItemAtividadeGeral extends ItemAtividade {
  projetoId: number;
  projetoNome: string;
}

export const montarAtividadeGeral = (projetos: ProjetoComEntradas[]): ItemAtividadeGeral[] => {
  const itens = projetos.flatMap(p =>
    montarTimeline(p.entradas).map(item => ({
      ...item,
      // Requalifica pelo projeto: "cp-1" de dois projetos diferentes colidiria sem isso.
      id: `${p.projetoId}-${item.id}`,
      projetoId: p.projetoId,
      projetoNome: p.projetoNome,
    })),
  );
  return itens.sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime());
};
